const multiSelect = {
  mapStates: function (statesNames) {
    let result = {}
    statesNames.forEach(i => {
      result[i] = {selected: [], loaded: []}
    })
    return result
  },
  mapGetters: function (statesNames) {
    let result = {}
    statesNames.forEach(i => {
      result[i] = function (state) {
        return state[i]
      }
    })
    return result
  },
  mapActions: function (statesNames) {
    let result = {}
    statesNames.forEach(i => {
      result[i] = function ({commit}, payload) {
        return commit(i, payload)
      }
    })
    return result
  },
  mapMutations: function (statesNames) {
    let result = {}
    statesNames.forEach(i => {
      result[i] = function (state, payload) {
        state[i] = {...state[i], ...payload}
      }
    })
    return result
  }
}

export default multiSelect
